/**
 * Staff API endpoints module
 * @module services/api/endpoints/staff
 * 
 * @param {Object} requester - The HTTP request handler
 * @returns {Object} Staff API methods
 */
export default requester => {
    return {
        /**
         * Gets all users from the user's staff
         *
         * @param {object} handle
         **/
        users(handle = {}) {
            return requester.get(`/users/${handle}/staff`);
        },

        /**
         * Get all staffs of the current user /me/staffs
         */
        all() {
            return requester.get('/me/staffs');
        },

        /**
         * Get all staffs from a specific platform
         * @param {*} platformSlug
         * @returns {Promise}
         */
        fromPlatform(platformSlug) {
            return requester.get(`/platforms/${platformSlug}/staff`);
        },

        /**
         * Get all staffs associated with a specific user ID
         * @param {string|number} userId - The ID of the user
         * @returns {Promise} Promise resolving to the staff data
         */
        fromUser(userId) {
            return requester.get(`/users/${userId}/staffs`);
        },

        /**
         * Start a session for a staff
         * @param {object} payload
         * @returns {Promise}
         */
        startSession(payload) {
            return requester.post(`/account/staffs/sessions`, payload);
        },

        /**
         * Remove a staff from a session
         * @param {string|number} staffId
         * @returns {Promise}
         */
        removeStaff(staffId) {
            return requester.delete(`/account/staffs/${staffId}`);
        },

        /**
         * Get all staffs of the current user
         */
        my(params = {}) {
            return requester.get(`/account/staffs`, { params });
        },

        /**
         * Add a staff member
         * @param {object} payload - The payload containing user_handle or user_id
         * @returns {Promise}
         */
        add(payload) {
            return requester.post(`/account/staffs`, payload);
        }
    };
}
